var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "48.167px",
    viewBox: "0 0 50 48.167",
    enableBackground: "new 0 0 50 48.167",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sign Out") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.241,39.681c0.935,0,1.693-0.759,1.693-1.692v-0.514c0-0.935-0.758-1.692-1.693-1.692h-4.157V12.384h4.157 c0.935,0,1.693-0.758,1.693-1.692v-0.515c0-0.934-0.758-1.692-1.693-1.692h-6.106c-1.077,0-1.95,0.873-1.95,1.95v27.296 c0,1.077,0.873,1.951,1.95,1.951L19.241,39.681L19.241,39.681z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.02,19.43l2.704,2.703H20.676c-0.934,0-1.692,0.758-1.692,1.692v0.515c0,0.935,0.758,1.692,1.692,1.692h15.047 l-2.704,2.703c-0.66,0.661-0.66,1.732,0,2.394l0.366,0.365c0.661,0.661,1.732,0.661,2.394,0l6.031-6.031 c0.763-0.76,0.763-1.995,0.002-2.757c-0.001-0.001-3.979-3.98-6.033-6.034c-0.661-0.661-1.547-0.847-1.979-0.416l-0.781,0.781 C32.359,17.698,32.359,18.77,33.02,19.43z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/signout.f7fefa31.svg";
export { ForwardRef as ReactComponent };